export default {
  'access-denied': {
    path: '/access-denied',
    isNoLayout: false,
    needPermission: false,
  },
};
